export type InputModality = 'desktop' | 'touch' | 'gamepad';

export function getInputModality(): InputModality {
  const nav = typeof navigator === 'undefined' ? null : navigator;
  const pads =
    typeof nav?.getGamepads === 'function'
      ? Array.from(nav.getGamepads()).filter((pad) => pad?.connected === true)
      : [];
  if (pads.length > 0) return 'gamepad';

  const hasTouch =
    (typeof nav?.maxTouchPoints === 'number' && nav.maxTouchPoints > 0) ||
    (typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(pointer: coarse)').matches);
  return hasTouch ? 'touch' : 'desktop';
}
